module.exports = __webpack_public_path__ + "img/ck.f16f2a32.png";